import React from 'react';
import Card from '../../ui/Card';
import { TrendingUpIcon, AlertCircleIcon } from 'lucide-react';
const DealerWalletShareMatrix: React.FC = () => {
  const dealerSegments = [{
    segment: 'High Revenue - High Share',
    dealers: 28,
    avgRevenue: 12.5,
    ourShare: 68,
    potential: 185,
    color: 'bg-green-500',
    textColor: 'text-green-700',
    bgLight: 'bg-green-50',
    priority: 'Maintain & Grow',
    icon: <TrendingUpIcon size={20} className="text-green-600" data-id="element-7279" />
  }, {
    segment: 'High Revenue - Low Share',
    dealers: 45,
    avgRevenue: 11.8,
    ourShare: 32,
    potential: 385,
    color: 'bg-yellow-500',
    textColor: 'text-yellow-700',
    bgLight: 'bg-yellow-50',
    priority: 'High Opportunity',
    icon: <AlertCircleIcon size={20} className="text-yellow-600" data-id="element-7280" />
  }, {
    segment: 'Low Revenue - High Share',
    dealers: 125,
    avgRevenue: 4.2,
    ourShare: 72,
    potential: 145,
    color: 'bg-blue-500',
    textColor: 'text-blue-700',
    bgLight: 'bg-blue-50',
    priority: 'Protect & Optimize',
    icon: <TrendingUpIcon size={20} className="text-blue-600" data-id="element-7281" />
  }, {
    segment: 'Low Revenue - Low Share',
    dealers: 336,
    avgRevenue: 3.8,
    ourShare: 28,
    potential: 1245,
    color: 'bg-gray-500',
    textColor: 'text-gray-700',
    bgLight: 'bg-gray-50',
    priority: 'Evaluate & Develop',
    icon: <AlertCircleIcon size={20} className="text-gray-600" data-id="element-7282" />
  }];
  return <Card className="p-6" data-id="element-7283">
      <h3 className="text-lg font-semibold text-gray-800 mb-2" data-id="element-7284">
        Dealer Wallet Share Matrix
      </h3>
      <p className="text-sm text-gray-600 mb-4" data-id="element-7285">
        Revenue vs wallet share segmentation
      </p>
      <div className="space-y-3" data-id="element-7286">
        {dealerSegments.map((segment, index) => <div key={index} className={`${segment.bgLight} border-2 border-gray-200 rounded-lg p-4 hover:shadow-md transition-shadow`} data-id="element-7287">
            <div className="flex items-start justify-between mb-3" data-id="element-7288">
              <div className="flex items-center" data-id="element-7289">
                {segment.icon}
                <div className="ml-3" data-id="element-7290">
                  <h4 className={`font-bold text-sm ${segment.textColor}`} data-id="element-7291">
                    {segment.segment}
                  </h4>
                  <p className="text-xs text-gray-600 mt-1" data-id="element-7292">
                    {segment.priority}
                  </p>
                </div>
              </div>
              <span className={`${segment.color} text-white text-xs font-bold px-3 py-1 rounded-full`} data-id="element-7293">
                {segment.dealers} dealers
              </span>
            </div>
            <div className="grid grid-cols-4 gap-3 text-xs" data-id="element-7294">
              <div data-id="element-7295">
                <div className="text-gray-500" data-id="element-7296">Avg Revenue</div>
                <div className="font-bold text-gray-900 mt-1" data-id="element-7297">
                  ₹{segment.avgRevenue} Cr
                </div>
              </div>
              <div data-id="element-7298">
                <div className="text-gray-500" data-id="element-7299">Our Share</div>
                <div className="font-bold text-gray-900 mt-1" data-id="element-7300">
                  {segment.ourShare}%
                </div>
              </div>
              <div data-id="element-7301">
                <div className="text-gray-500" data-id="element-7302">Potential</div>
                <div className="font-bold text-gray-900 mt-1" data-id="element-7303">
                  ₹{segment.potential} Cr
                </div>
              </div>
              <div data-id="element-7304">
                <div className="text-gray-500" data-id="element-7305">Opportunity</div>
                <div className="font-bold text-green-600 mt-1" data-id="element-7306">
                  {segment.ourShare < 50 ? 'High' : 'Medium'}
                </div>
              </div>
            </div>
            <div className="mt-3 pt-3 border-t border-gray-200" data-id="element-7307">
              <div className="flex items-center" data-id="element-7308">
                <div className="flex-1 h-2 bg-gray-200 rounded-full overflow-hidden" data-id="element-7309">
                  <div className={`h-full ${segment.color}`} style={{
                width: `${segment.ourShare}%`
              }} data-id="element-7310" />
                </div>
                <span className="ml-2 text-xs font-semibold text-gray-700" data-id="element-7311">
                  {segment.ourShare}% share
                </span>
              </div>
            </div>
          </div>)}
      </div>
      <div className="mt-6 pt-6 border-t border-gray-200" data-id="element-7312">
        <div className="grid grid-cols-2 gap-4 text-sm" data-id="element-7313">
          <div className="text-center" data-id="element-7314">
            <div className="text-gray-600" data-id="element-7315">Total Opportunity</div>
            <div className="text-2xl font-bold text-green-600" data-id="element-7316">₹1,960 Cr</div>
          </div>
          <div className="text-center" data-id="element-7317">
            <div className="text-gray-600" data-id="element-7318">Avg Wallet Share</div>
            <div className="text-2xl font-bold text-blue-600" data-id="element-7319">42%</div>
          </div>
        </div>
      </div>
    </Card>;
};
export default DealerWalletShareMatrix;